interface ProductProps {
  SAPLeadTime: SAPLeadTimeProps;
  SAPPricingInfo: SAPPricingInfoProps;
  AvailableInventoryList: any[];
  IsUserLoggedIn: boolean;
  ProductNumber: string;
  ProductStatus: any[];
  TempProductNumber: string;
  Quantity: string;
  InventoryStatusCode: number;
  InventoryStatusMessage: string;
  PricingStatusMessage: string;
  calculatedPricing: any;
  isProductDiscontinued: boolean;
  ReplacementProductText: string | null;
  ReplacementProductUrl: string | null;
  MainImage: string | null;
  isSubmitted: boolean;
  User: any;
}

interface SAPPricingInfoProps {
  ProductId: string;
  FormattedPrice: string;
  FormattedMSRP: string;
  RawPrice: number;
  RawMSRP: number;
  CurrencyCode: string;
  LeadTime: number;
}

interface SAPLeadTimeProps {
  SAPDelivaryDate: string;
  SAPStatusCode: string;
  Icon: string;
  IconColor: string;
  OutlineColor: string;
  Message: string;
  IsAddToCartHidden: boolean;
  IsAddToQuoteHidden: boolean;
  PriceReplacementMessage: string;
}

export const initProductData: ProductProps = {
  SAPLeadTime: {
    SAPDelivaryDate: "",
    SAPStatusCode: "",
    Icon: "",
    IconColor: "",
    OutlineColor: "",
    Message: "",
    IsAddToCartHidden: false,
    IsAddToQuoteHidden: false,
    PriceReplacementMessage: "",
  },
  SAPPricingInfo: {
    ProductId: "",
    FormattedPrice: "",
    FormattedMSRP: "",
    RawPrice: 0,
    RawMSRP: 0,
    CurrencyCode: "",
    LeadTime: 0,
  },
  AvailableInventoryList: [],
  ProductNumber: "",
  ProductStatus: [],
  TempProductNumber: "",
  Quantity: "1",
  InventoryStatusCode: 0,
  InventoryStatusMessage: "",
  PricingStatusMessage: "",
  IsUserLoggedIn: false,
  calculatedPricing: {},
  isProductDiscontinued: false,
  ReplacementProductText: null,
  ReplacementProductUrl: null,
  MainImage: null,
  isSubmitted: false,
  User: {},
};

// if reducer logic becomes more complex, consider moving to service
const discontinuedCheck = (payload: any) => {
  const discontinuedStatusCode = 3;
  return discontinuedStatusCode === payload?.InventoryStatusCode;
};

export const productReducer = (
  state = initProductData,
  { type, payload }: { type: string; payload: any },
) => {
  switch (type) {
    case "SET_PRODUCT":
      discontinuedCheck(payload);
      return {
        ...payload,
        isProductDiscontinued: discontinuedCheck(payload),
      };
    case "SET_PRODUCT_NUMBER":
      return {
        ...state,
        ProductNumber: payload,
      };
    case "SET_TEMP_PRODUCT_NUMBER":
      console.log(payload);
      return {
        ...state,
        TempProductNumber: payload,
      };
    case "SET_COUNTER_QUANTITY":
      return {
        ...state,
        Quantity: payload,
      };
    case "SET_CALCULATED_PRICING":
      return {
        ...state,
        calculatedPricing: payload,
      };
    case "SET_SUBMITTED":
      return {
        ...state,
        isSubmitted: payload,
      };
    case "SET_USER":
      return {
        ...state,
        User: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};
